export default "__VITE_ASSET__sQrFvmTd__"